import { useContext, useEffect, useState as classicUseState } from 'react';

import ProductImage from '@assets/png/product.png';

import { IProduct } from '@models/Product.model';

import {
  LoadingImg,
  LoadingText,
  LoadMore,
} from '@pages/Products/components/ListProducts/ListProducts.styles';
import Rolling from '@assets/gif/rolling.gif';
import { useInView } from 'react-intersection-observer';
import { ListProductsLoading } from '@pages/Products/components/ListProducts/loading/ListProducts.loading';
import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';

import { CSSTransition } from 'react-transition-group';
import { Block } from '@pages/Products/components/AddEquipmentModal/components/AddProduct/AddProduct.styles';
import { useState } from '@hookstate/core';
import { ProductDetail } from '@pages/Products/components/AddEquipmentModal/components/SelectBody/components/ListEquipmentsWithMatch/components';
import {
  manualAddProductDetails,
  manualAddSelectProduct,
} from '@services/mixpanel/trackers/ManualAdd';
import { NavigationContext } from '@layout/navigation/navigation';
import {
  MatchButton,
  ColumnDiv,
  ProductDiv,
  Td,
  ProductHeader,
  LinkText,
  ScrollDiv,
  DetailButton,
  TextMatches,
} from './ListEquipmentsWithMatch.styles';
import { Container, Image } from '../../../tables.styles';

interface ListProductsProps {
  data?: IProduct[];
  isLoading: boolean;
  loadMore: () => void;
  updateDataSelected: (productRequest?: ProductRequest[]) => void;
  hasMore?: boolean;
  nextBody: () => void;
}

const ListEquipmentsWithMatch = ({
  data,
  isLoading,
  hasMore,
  loadMore,
  updateDataSelected,
  nextBody,
}: ListProductsProps) => {
  const { ref, inView } = useInView();
  const open = useState(false);
  const [detailProduct, setDetailProduct] = classicUseState<
    IProduct | undefined
  >(undefined);

  const { studioName } = useContext(NavigationContext);

  useEffect(() => {
    if (inView && hasMore) loadMore();
  }, [inView, hasMore]);
  if (isLoading) {
    return <ListProductsLoading />;
  }
  if (!data) {
    return <div />;
  }
  return (
    <Container>
      <TextMatches>{`${data.length} Potential Matches found!`}</TextMatches>
      <ScrollDiv>
        {data.map(item => (
          <ProductDiv key={JSON.stringify(item)}>
            <Td width={20}>
              {item.imageUrl ? (
                <Image src={item.imageUrl} alt="" />
              ) : (
                <Image src={ProductImage} alt="" />
              )}
              <ColumnDiv>
                <ProductHeader>Model #</ProductHeader>

                {item.model}
              </ColumnDiv>
            </Td>
            <Td width={50}>
              <ColumnDiv>
                <ProductHeader>Product Name</ProductHeader>

                {item.name}
              </ColumnDiv>
            </Td>

            <Td width={30}>
              <ColumnDiv>
                <ProductHeader>
                  {item.productPage &&
                  !item.productPage.includes('wwUw.bhphotovideo.com')
                    ? 'Product Page'
                    : ''}
                </ProductHeader>
                <LinkText
                  onClick={() => {
                    if (
                      item.productPage &&
                      !item.productPage.includes('www.bhphotovideo.com')
                    )
                      window.open(item.productPage, '_blank');
                  }}
                >
                  {item.productPage &&
                  !item.productPage.includes('www.bhphotovideo.com')
                    ? `${item.model.length > 0 ? item.model : 'Product'} Page`
                    : ''}
                </LinkText>
              </ColumnDiv>
            </Td>
            <DetailButton
              onClick={() => {
                setDetailProduct(item);
                open.set(true);
                manualAddProductDetails(studioName, item.id);
              }}
            >
              Full Details
            </DetailButton>
            <MatchButton
              onClick={() => {
                updateDataSelected([
                  {
                    product: item,
                    quantity: 1,
                    id: `${item.manufacturerId}-${item.id}`,
                  },
                ]);
                nextBody();
                manualAddSelectProduct(studioName, item.id, item.name);
              }}
            >
              Match
            </MatchButton>
          </ProductDiv>
        ))}
        <LoadMore ref={ref}>
          {hasMore ? (
            <LoadMore>
              <LoadingText>Loading more</LoadingText>
              <LoadingImg src={Rolling} alt="loading" />
            </LoadMore>
          ) : (
            <div />
          )}
        </LoadMore>
      </ScrollDiv>
      <CSSTransition
        in={open.get()}
        timeout={1}
        classNames="my-node"
        unmountOnExit
        onEnter={() => open.set(true)}
        onExited={() => open.set(false)}
      >
        <Block>
          <ProductDetail
            openAddField={open}
            detailProduct={detailProduct}
            onClickMatch={() => {
              if (detailProduct)
                updateDataSelected([
                  {
                    product: detailProduct,
                    quantity: 1,
                    id: `${detailProduct.manufacturerId}-${detailProduct.id}`,
                  },
                ]);
              nextBody();
            }}
          />
        </Block>
      </CSSTransition>
    </Container>
  );
};

export { ListEquipmentsWithMatch };
